/**
 * Utility for virtual short ID logic on the FE.
 * The short ID is the first 8 characters of a UUID.
 */

/**
 * Gets the short ID from a full UUID.
 * @param uuid The full UUID string
 * @returns The first 8 characters of the UUID
 */
export function getShortIdFromUuid(uuid: string): string {
  if (!uuid) return '';
  // UUIDs are typically 36 characters (including hyphens)
  // The first segment is 8 hex characters.
  return uuid.split('-')[0].substring(0, 8);
}

/**
 * Formats a short ID for display.
 * @param shortId The 8-character short ID
 * @returns Upper-case formatted short ID
 */
export function formatShortId(shortId: string): string {
  if (!shortId) return '';
  return shortId.toUpperCase();
}

/**
 * Checks if a string is a valid short ID (8 hex characters).
 * @param id The ID to check
 * @returns True if valid short ID format
 */
export function isValidShortId(id: string): boolean {
  return /^[0-9a-fA-F]{8}$/.test(id);
}
